import React, { useEffect, useState } from "react";
import {
  FaEnvelope,
  FaEye,
  FaEyeSlash,
  FaLock,
  FaPaperPlane,
  FaSpinner,
} from "react-icons/fa6";
import { LiaTimesCircle } from "react-icons/lia";
import { adminLogin, forgottenPassword } from "../../Auth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getContactInfo, passwordResetMail } from "../../AppManager";

function Admin() {
  const params = useSearchParams()[0];
  const next = params.get("next");
  const message = params.get("message");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState({
    status: "",
    type: "",
    message: message ? message : "",
  });
  const [loading, setLoading] = useState(false);
  const [showp, setShowp] = useState(false);
  const [redirection, setRedirection] = useState("");
  const [forgotPage, setForgotPage] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  useEffect(() => {
    if (redirection !== "") {
      navigate(redirection.path, redirection.options);
    }
  }, [redirection, navigate]);

  function handleChange(e) {
    const { name, value } = e.target;
    if (name === "password") {
      setPassword(value);
    }
  }

  function success() {
    setStatus({
      status: "success",
      type: "success",
      message: "Log-In Successful. Redirecting...",
    });
    setTimeout(() => {
      if (next) {
        setRedirection({ path: next });
      } else {
        setRedirection({ path: "/admin" });
      }
    }, 1000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await adminLogin(password);

      if (res === "Confirmed") {
        success();
      } else if (res === "Attempts") {
        setStatus({
          status: "Attempts",
          type: "failed",
          message: "Too many login attempts. Please try again later.",
        });
        setLoading(false);
      } else if (res === "Incorrect") {
        setStatus({
          status: "Incorrect",
          type: "failed",
          message: "Incorrect Password",
        });
        setLoading(false);
      } else {
        setStatus({ status: "error", type: "failed", message: "Login Failed" });
        setLoading(false);
      }
    } catch (error) {
      setStatus({ status: "error", type: "failed", message: "Login Failed" });
      setLoading(false);
    }
  }

  function toggleShow() {
    setShowp((oldShowp) => !oldShowp);
  }

  async function handleForgotSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { email } = await getContactInfo();

      if (email !== forgotEmail.trim()) {
        setLoading(false);
        return setStatus({
          status: "Not Found",
          type: "failed",
          message: "E-Mail not Recognized",
        });
      }

      const matric = process.env.REACT_APP_ADMIN_MATRIC;
      const res = await forgottenPassword(matric, "admin");
      if (res[0] === "Success") {
        const success = {
          status: "success",
          type: "success",
          message: "Password Reset Link sent to E-Mail",
        };
        const fail = {
          status: "failed",
          type: "failed",
          message: "Request Failed",
        };
        const reset = "";
        passwordResetMail(
          res[1],
          res[2],
          res[3],
          setStatus,
          setForgotEmail,
          setLoading,
          success,
          fail,
          reset
        );
      } else if (res[0] === "Not Found") {
        setStatus({
          status: "Not Found",
          type: "failed",
          message: "Matric not Registered",
        });
        setLoading(false);
      } else if (res[0] === "Exists") {
        setStatus({
          status: "Exists",
          type: "failed",
          message: "Previous Reset Link Unused",
        });
        setLoading(false);
      } else {
        setStatus({
          status: "failed",
          type: "failed",
          message: "Request Failed",
        });
        setLoading(false);
      }
    } catch (error) {
      setStatus({
        status: "failed",
        type: "failed",
        message: "Request Failed",
      });
      setLoading(false);
    }
  }

  useEffect(() => {
    if (status.message !== "") {
      document
        .getElementById("status-wrapper")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status]);

  document.title = "Admin Login";

  return (
    <section className="contactform loginform">
      <div className="formwrapper">
        <div className={`wrapper ${forgotPage ? "active-forgot" : ""}`}>
          <div className="form-box login">
            <h2>Admin Login</h2>
            <form onSubmit={handleSubmit}>
              {status.message !== "" && (
                <p className="status-wrapper" id="status-wrapper">
                  <span className={`status-message ${status.type}`}>
                    {status.message}
                  </span>
                  <LiaTimesCircle
                    className="status-close"
                    onClick={() => {
                      setStatus({ status: "", type: "", message: "" });
                    }}
                  />
                </p>
              )}
              <div className="input-box">
                <span className="icon">
                  {!showp && (
                    <FaEye
                      style={{ cursor: "pointer" }}
                      className="ico"
                      onClick={toggleShow}
                    />
                  )}
                  {showp && (
                    <FaEyeSlash
                      style={{ cursor: "pointer" }}
                      className="ico"
                      onClick={toggleShow}
                    />
                  )}
                </span>
                <input
                  readOnly={loading}
                  placeholder=" "
                  name="password"
                  type={showp ? "text" : "password"}
                  value={password}
                  autoComplete="off"
                  onChange={handleChange}
                  required
                />
                <label>
                  <FaLock /> Password
                </label>
              </div>
              <div className="remember-forgot">
                <span
                  className="forgot-link"
                  onClick={() => {
                    setForgotPage(true);
                    setStatus({ status: "", type: "", message: "" });
                  }}
                >
                  Forgot Password?
                </span>
              </div>
              <button type="submit" className="btn" disabled={loading}>
                {loading ? <FaSpinner className="spinner" /> : "Login"}
              </button>
            </form>
          </div>
          <div className="form-box forgotpassword">
            <h2>Forgot Password</h2>
            <form onSubmit={handleForgotSubmit}>
              {status.message !== "" && (
                <p className="status-wrapper" id="status-wrapper">
                  <span className={`status-message ${status.type}`}>
                    {status.message}
                  </span>
                  <LiaTimesCircle
                    className="status-close"
                    onClick={() => {
                      setStatus({ status: "", type: "", message: "" });
                    }}
                  />
                </p>
              )}
              <div className="input-box">
                <span className="icon">
                  <FaEnvelope />
                </span>
                <input
                  readOnly={loading}
                  placeholder=" "
                  name="email"
                  maxLength={100}
                  type="email"
                  onChange={(e) => setForgotEmail(e.target.value)}
                  value={forgotEmail}
                  autoComplete="off"
                  required
                />
                <label htmlFor="">E-Mail</label>
              </div>
              <button type="submit" className="btn" disabled={loading}>
                {loading ? (
                  <FaSpinner className="spinner" />
                ) : (
                  <>
                    <FaPaperPlane /> Send Link
                  </>
                )}
              </button>
              <div className="login-register">
                <p>
                  <span
                    className="return-link"
                    onClick={() => {
                      setForgotPage(false);
                      setStatus({ status: "", type: "", message: "" });
                    }}
                  >
                    Login
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Admin;
